import React, { FC } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Context } from "../../..";

interface IQuillProps {
  placeholder?: string;
  value?: string;
  onChange?: (val: string) => void;
  style?: any;
  readOnly?: any;
}

export const Editor: FC<IQuillProps> = ({
  placeholder,
  value,
  onChange,
  style,
  readOnly,
}) => {
  const _quillRef = React.useRef<ReactQuill>(null);
  const { articles } = React.useContext(Context);

  const imageHandler = async () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      // @ts-ignore
      const file: any = input.files ? input.files[0] : null;

      await uploadFiles(file, _quillRef.current);
    };
  };

  const uploadFiles = async (file: any, quill: any) => {
    if (quill && file) {
      // Get the current selection range
      const range = quill.getEditorSelection();
      const response = await articles.uploadImage(file);
      quill.getEditor().insertEmbed(range.index, "image", response);

      // Calculate the new index to move the cursor
      const newIndex = range.index + 1;

      // Set the selection to the new index
      quill.getEditor().setSelection(newIndex);
    }
  };

  const modules = React.useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: "1" }, { header: "2" }],
          [{ font: [] }],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ script: "sub" }, { script: "super" }],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "script",
    "list",
    "bullet",
    "indent",
    "color",
    "background",
    "align",
    "link",
    "image",
    "clean",
  ];

  return (
    <ReactQuill
      ref={_quillRef}
      theme="snow"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      preserveWhitespace
      style={style}
      readOnly={readOnly}
    ></ReactQuill>
  );
};
